import React from "react";
import { ResponsiveImage } from "@quintype/components";
import { object } from "prop-types";
import assetify from "@quintype/framework/assetify";
import { connect } from "react-redux";
import get from "lodash/get";

import { CollectionName } from "../../atoms/collection-name";
import NlPodcast from "../../../../assets/images/nlpodcast.png";

import "./nl-podcast.m.css";
import { getGlobalPlayerRef } from "../../podcast-player/utils";

const NlPodcastRowBase = ({ collection, config }) => {
  const collections = collection.items.filter(collection => collection.type === "collection");
  const defaultImgS3Key = get(config, ["publisher", "publisher", "defaulImgS3key"], "");
  if (collections.length < 1) {
    return null;
  }

  const getCollectionItems =
    collections.filter(collection => {
      return collection.items && collection.items.length > 0 && collection;
    }) || [];

  const handlePodcastClick = () => {
    const playerRef = getGlobalPlayerRef();
    playerRef.setCurrentScreen("library");
  };

  return (
    <div className="full-width-with-padding" styleName="wrapper">
      <div className="full-width-with-padding" styleName="inner-wrapper">
        <div className="container">
          <div styleName="main-grid">
            <div>
              <CollectionName collection={collection} color="#fff" />
              {collection.summary && <h2 styleName="summary">{collection.summary}</h2>}
            </div>
            <div styleName="story-wrapper">
              {getCollectionItems.slice(0, 6).map((collection, index) => {
                const coverImgUrl = get(collection, ["metadata", "cover-image", "cover-image-s3-key"], defaultImgS3Key);
                const coverImgMetadata = get(collection, ["metadata", "cover-image", "cover-image-metadata"], {});
                return (
                  <button className="pressable" onClick={handlePodcastClick} key={index}>
                    <figure styleName="image-wrapper">
                      <ResponsiveImage
                        slug={coverImgUrl}
                        metadata={coverImgMetadata}
                        aspectRatio={[179, 239]}
                        styleName="image"
                        defaultWidth={259}
                        widths={[250, 375]}
                        alt={collection.name}
                      />
                    </figure>
                    <h3 styleName="headline">{collection.name}</h3>
                  </button>
                );
              })}
            </div>
            {getCollectionItems.length > 3 && (
              <div styleName="default-img">
                <img src={assetify(NlPodcast)} alt="nl-podcast"></img>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

NlPodcastRowBase.propTypes = {
  collection: object,
  config: object
};

NlPodcastRowBase.storyLimit = 18;

function mapStateToProps(state) {
  return {
    config: get(state, ["qt", "config"], {})
  };
}

export const NlPodcastRow = connect(mapStateToProps)(NlPodcastRowBase);
